import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { TestService } from 'src/app/shared/test.service';
import { TestProfileTestLimit, TestViewModel } from 'src/app/shared/models/test.model';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';

import { MatButton } from '@angular/material/button';
@Component({
    selector: 'app-limit-editor-dialog',
    templateUrl: './limit-editor-dialog.component.html',
    styleUrls: ['./limit-editor-dialog.component.css'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, ReactiveFormsModule, FormsModule, MatFormField, MatLabel, MatSelect, MatOption, MatButton]
})
export class LimitEditorDialogComponent implements OnInit {

  testlist: TestViewModel[];

  

  constructor(
    public dialogRef: MatDialogRef<LimitEditorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public limit: TestProfileTestLimit,
    private _testService: TestService) { }

  ngOnInit() {

    this._testService.getMultiplierTests(this.limit.ProfileId).subscribe((t: TestViewModel[])=>{
        this.testlist = t;
    });

  
    //console.log(this.limit);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  save(){
    
    this._testService.updateLimitSettings(this.limit).subscribe(res=>{
      //console.log(this.limit);
      if(res)
        this.dialogRef.close();
    });



  }

}
